import React from 'react';
import Login from '../../containers/auth/Login';

const ViewLogin = () => <Login />;

export default ViewLogin;
